var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#F2F3F4",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440 1247 c-97 -33 -157 -72 -240 -156 -117 -117 -175 -247 -186 -411 -8 -113 13 -210 71 -326 37 -76 58 -104 123 -166 129 -121 266 -178 432 -179 114 -1 194 16 287 62 l78 38 27 -32 c33 -40 40 -34 67 64 26 92 26 116 3 123 -35 10 -202 18 -202 10 0 -5 9 -20 20 -34 11 -14 20 -30 20 -37 0 -16 -113 -68 -178 -82 -241 -50 -487 71 -593 293 -46 96 -61 182 -49 287 26 232 185 410 418 469 50 13 71 44 53 79 -15 28 -66 27 -151 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722 1258 c-19 -19 -15 -66 7 -78 27 -14 84 -13 99 2 19 19 14 55 -10 72 -27 19 -79 21 -96 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 1180 c-6 -12 -8 -29 -5 -39 13 -40 91 -69 117 -43 19 19 12 64 -13 83 -33 26 -85 25 -99 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066 1064 c-22 -21 -20 -50 5 -85 14 -20 29 -29 48 -29 57 0 69 54 22 101 -33 33 -52 36 -75 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160 885 c-17 -20 -5 -77 20 -100 16 -15 26 -17 48 -9 24 9 27 15 26 51 0 23 -6 49 -14 57 -16 20 -64 21 -80 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908 856 c-35 -18 -123 -63 -196 -100 l-132 -68 2 -220 c3 -198 5 -222 21 -232 12 -8 22 -8 35 0 15 10 17 33 20 205 l3 194 168 87 c93 49 174 94 180 102 14 17 1 50 -24 59 -8 4 -43 -9 -77 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206 694 c-21 -20 -21 -88 0 -108 38 -38 74 -12 74 54 0 66 -36 92 -74 54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177 497 c-23 -16 -34 -82 -17 -102 7 -8 26 -15 42 -15 24 0 32 6 44 35 18 44 18 60 -2 79 -19 19 -44 20 -67 3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.41b32420ad52161b569402f0417c13ae.svg";
export { ForwardRef as ReactComponent };